/* eslint-disable @typescript-eslint/consistent-type-definitions -- Zero mutator/query arg types must be `type` aliases to satisfy the ReadonlyJSONValue constraint; interfaces lack an implicit index signature. */
import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx, Schema } from "../schema"
import type { DeleteID } from "@rocicorp/zero"

export type CreateForwardedEmailIgnoreSenderArgs = {
	id: string
	email: string
}

function normalizeEmail(email: string): string {
	return email.toLowerCase().trim()
}

export const forwardedEmailIgnoreSenderMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateForwardedEmailIgnoreSenderArgs
			ctx: ZeroJwtPayload
		}) => {
			const normalizedEmail = normalizeEmail(args.email)

			const [existing] = await tx.query.forwardedEmailIgnoreSender
				.where("workspaceId", "=", authData.workspaceId)
				.where("email", "=", normalizedEmail)
				.run()

			if (existing) {
				throw new Error("Forwarded email ignore sender already exists")
			}

			await tx.mutate.forwardedEmailIgnoreSender.insert({
				id: args.id,
				createdAt: Date.now(),
				workspaceId: authData.workspaceId,
				email: normalizedEmail,
			})
		},
	),
	delete: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: DeleteID<Schema["tables"]["forwardedEmailIgnoreSender"]>
		}) => {
			await tx.mutate.forwardedEmailIgnoreSender.delete({ id: args.id })
		},
	),
}
